import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges, ViewChild
} from "@angular/core";
import {AccountModel} from "../../models/account.model";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import * as _ from "lodash";
import * as angular from "angular";
import {
  DemandAccountsMultiSelectListComponent
} from "../demand-accounts-multi-select-list/demand-accounts-multi-select-list.component";
import {AccountsComponentStore} from "../../state/accounts-component.store";
import {Subscription} from "rxjs";

require('./demand-accounts-multi-select.scss');
@Component({
  standalone: false,
  selector: 'app-demand-accounts-multi-select',
  templateUrl: './demand-accounts-multi-select.html',
  providers: [AccountsComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandAccountsMultiSelectComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() accounts: AccountModel[];
  @Input() selectedIds: any;
  @Input() branchIds: any[];
  @Input() options: any;
  @Input() optionIds: any;
  @Input() ngPlaceholder: any;
  @Input() excludeIds: any;
  @Input() isDisabled: any;
  @Input() isRequired: boolean;
  @Output() onChange = new EventEmitter<any>();

  @ViewChild('inputRef', {static: true}) inputRef: ElementRef;


  public selectedAccounts: any;
  public selectedText: any;
  public accountsSubscription: Subscription;

  constructor(@Inject(PanelService) private panelService: PanelService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(AccountsComponentStore) private accountsStore: AccountsComponentStore, @Inject('$timeout') private $timeout) {
  }

  ngOnInit() {
    // if(this.selectedIds)
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      let currentSelectedIds = _.get(changes.selectedIds, 'currentValue', []),
        previousSelectedIds = _.get(changes.selectedIds, 'previousValue', []),
        idsToRemove: string[] = _.differenceBy(previousSelectedIds, currentSelectedIds),
        idsToAdd: string[] = _.difference(currentSelectedIds, previousSelectedIds);

      if (idsToAdd?.length) {
        this.accountsStore.getAccounts({ids: idsToAdd});
      }
      if (idsToRemove?.length) {
        this.accountsStore.removeAccounts(idsToRemove);
      }
      this._setSelectedAccounts();
    }
  }

  ngAfterViewInit() {
    this._setSelectedAccounts();
    this.accountsSubscription = this.accountsStore.vm$.subscribe((vm) => {

      if (!!vm.accounts.length) {
        this.selectedAccounts = _.orderBy(vm.accounts, ['name'], ['asc']);
        this._setSelectedText();
      }
      this.cdr.detectChanges();
    })

  }

  ngOnDestroy() {
    this.accountsStore.onResetAccounts();
    this.accountsSubscription.unsubscribe();
  }


  onResetFilter() {
    this.onChange.emit({accountIds: [], accounts: []});
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(DemandAccountsMultiSelectListComponent, event, {
      selectedIds: this.selectedIds,
      excludeIds: this.excludeIds,
      branchIds: this.branchIds
    })

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        this.onChange.emit({accountIds: data?.accountIds || this.selectedIds});

        // this.$timeout(0).then(() => {
        // });
      })
    }
  }

  private _setSelectedAccounts() {
    if (!!this.accounts) {
      this.selectedAccounts = angular.copy(this.accounts);
    } else if (!!this.selectedIds?.length) {
      if (!!this.options) {
        this.selectedAccounts = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
      } else {
        this.accountsStore.getAccounts({ids: this.selectedIds});
      }

    } else {
      this.selectedAccounts = [];
    }

    this._setSelectedText();
  }

  private _setSelectedText() {
    if (!this.selectedAccounts?.length) {
      this.selectedText = '';
      return;
    }

    let string = this.selectedAccounts.map(b => b.name).join(', ');

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");
    const inputWidth = this.inputRef?.nativeElement?.clientWidth;

    if (!ctx || !inputWidth) return;
    const textWidth = ctx.measureText(string).width;

    if (inputWidth - 50 < textWidth) {
      string = `${this.selectedAccounts[0].name} +${this.selectedAccounts.length - 1}`;
    }
    this.selectedText = string;
  }


}
